<template>
  <section>
    <collapsable
      :collapsed="collapsed"
      :collapsable="collapsable"
      :title="$t('menu.kiosks')"
    >

      <span slot="beforeCollapse" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="filters.querySearch" />
        <Filters
          v-if="shouldShowFilters"
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters"
        />
      </span>

      <div v-if="shouldShowFilters && showFilters" class="kiosks-table-filters row">
        <div class="col-12 col-md-4">
          <multiselect
            v-model="filters.entity"
            :options="readableEntities"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('statistics.select_entity')"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            >
            </multiselect>
        </div>
      </div>

      <v-server-table
        id="kiosksTable"
        ref="kiosksTable"
        name="kiosksTable"
        :columns="columns"
        :options="tableOptions"
        @row-click="onRowClicked"
      >
        <span slot="serial" slot-scope="props">
          {{props.row.device_serial ? props.row.device_serial : props.row.serial}}
        </span>
        <span slot="kiosk_type" slot-scope="props">
          {{props.row.kiosk_type ? $t(kioskTypesAdapter[props.row.kiosk_type]) : 'N/A'}}
        </span>
        <span slot="entity" slot-scope="props">
          {{props.row.entity ? props.row.entity.name : 'N/A'}}
        </span>
        <span slot="owner" slot-scope="props">
          {{props.row.active_license && props.row.active_license.entity ? props.row.active_license.entity.name : 'N/A'}}
        </span>
        <span slot="licensed_until" slot-scope="props">
          {{props.row.active_license ? props.row.active_license.end_date : 'N/A'}}
        </span>
        <span slot="checkin_at" slot-scope="{row}">
          {{row.checkin_at | localTime }}
        </span>
        <span slot="last_promoter_id" slot-scope="props">
          {{props.row.last_promoter_id ? props.row.last_promoter_id : 'N/A'}}
        </span>

      </v-server-table>
    </collapsable>

    <create-or-update-kiosk v-if="selectedKiosk !== null"
      :kiosk="selectedKiosk"
      @updated="onKioskUpdated"
      @modalClosed="onKioskModalClosed"
    >
    </create-or-update-kiosk>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Collapsable from '@/components/common/Collapsable'
import CreateOrUpdateKiosk from '@/components/licenses/kiosks/CreateOrUpdate'

export default {
  components: {
    Multiselect,
    Searchable,
    Collapsable,
    Filters,
    CreateOrUpdateKiosk
  },
  props: {
    entity: {
      type: Object,
      required: false
    },
    shouldShowFilters: {
      type: Boolean,
      required: false,
      default: true
    },
    collapsed: {
      type: Boolean,
      required: false
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data () {
    return {
      showFilters: false,
      filters: {
        querySearch: '',
        entity: null
      },
      selectedKiosk: null,
      kioskTypesAdapter: {
        1: 'kiosks.regular_kiosk',
        2: 'kiosks.portable_kiosk'
      },
      columns: ['created_at', 'serial', 'name', 'kiosk_type', 'owner', 'entity', 'licensed_until', 'version', 'checkin_at', 'last_promoter_id'],
      queryUrl: this.$store.state.evollead_server + '/kiosks',
      tableOptions: {
        filterable: ['name', 'entity'],
        sortable: ['name', 'version', 'kiosk_type', 'licensed_until', 'checkin_at', 'created_at'],
        headings: {
          name: this.$t('users.inputs.name'),
          serial: 'Serial',
          kiosk_type: this.$t('kiosks.type'),
          version: this.$t('kiosks.version'),
          licensed_until: this.$t('kiosks.licensed_until'),
          owner: this.$t('kiosks.owner'),
          entity: this.$t('kiosks.entity'),
          checkin_at: this.$t('kiosks.checkin_at'),
          last_promoter_id: this.$t('kiosks.promoter'),
          created_at: this.$t('kiosks.created_at')
        },
        columnsDropdown: false,
        saveState: false,
        customFilters: ['entity', 'owner'],
        initFilters: {
          entity: ''
        }
      },
    }
  },
  created () {
    this.selectStartingEntity()
  },
  methods: {
    selectStartingEntity: function () {
      if (!this.entity && this.readableEntities.length > 0) {
        let ownEntity = this.readableEntities.find(entity => entity.id === this.$auth.user().entity.id)
        if (ownEntity) {
          this.filters.entity = ownEntity
        } else {
          this.filters.entity = this.readableEntities[0]
        }
      }
      if (this.filters.entity) {
        this.tableOptions.initFilters.entity = this.filters.entity.id
      }
    },
    onRowClicked: function ({ row }) {
      this.selectedKiosk = row
    },
    onKioskUpdated: function () {
      this.$refs.kiosksTable.refresh()
    },
    onKioskModalClosed: function () {
      this.selectedKiosk = null
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    getTableReference: function () {
      return this.$refs.kiosksTable
    }
  },
  filters: {
    formatDate: function (date) {
      return this.moment(date).format('DD-MM-YYYY')
    }
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.evollead_server)
    },
    readableEntities: function () {
      return this.leadsService.entities.filter(entity => {
        return this.leadsService.user_permissions.some(p => p.info_type === 110 && p.access_type >= 1 && (p.entity_id === null || p.entity_id === entity.id))
      })
    },
    activeFilters: function () {
      let count = 0
      if (this.filters.entity !== null) count++
      return count
    }
  },
  watch: {
    'entity': {
      handler: function (entity) {
        this.filters.entity = entity
      },
      immediate: true
    },
    'filters.entity': function (newValue) {
      this.emitTableFilter('vue-tables.kiosksTable.filter::entity', newValue ? newValue.id : '')
    },
    'filters.querySearch': function (newValue) {
      this.$refs.kiosksTable.setFilter(newValue)
    }
  }
}
</script>

<style lang="scss">

#kiosksTable {
  .VueTables__search {
      display: none;
    }
}

</style>
